/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, {
    useCallback, useContext, useEffect, useState
} from 'react';
import _ from 'lodash';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { MLPublicContactsService, MLAddressVerificationService, LoadSaveService, EmailValidationService } from 'gw-capability-quoteandbind';
import { AddtlInterestDriverComponent, AddtlInterestExcludedDriverComponent } from 'ml-capability-quoteandbind-common-react';
import { MLDriverVehicleUtil, MLNotificationBlockUtil, MLWizardNavUtil } from 'ml-portals-util-react';
import { MLPortalStorageService, MLBundleService, MLMultiLobsDataHolderService } from 'ml-services-common-react';
import { MLEditContactDetailsComponent, MLAddressDetailsComponent } from 'ml-components-common-react';
import { MLModalService } from 'ml-portals-services-react';
import { platformMessages } from 'ml-components-platform-react';
import { MLDisclosureUtil } from 'ml-portals-util-js';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import wizardConfig from "../../config/pa-wizard-config.json5";

import PATrackEvent from '../../../gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/PATrackEvent';

import metadata from './AdditionalInformationPreBindPage.metadata.json5';
import messages from './AdditionalInformationPreBindPage.messages';
import styles from './AdditionalInformationPreBindPage.module.scss';
import { ScrollToError } from '@jutro/legacy/wizard-next';

const {
    ML_STORAGE_KEY_PREVIOUS_PREMIUM
} = appConfig;

const AdditionalInformationPreBindPage = (props) => {
    const { CustomQuoteService } = useDependencies('CustomQuoteService');
    const { authHeader } = useAuthentication();
    const translator = useTranslator();
    const ADDLINTERESTSUBTYPE = 'PAVhcleAddlInterest';
    const {
        wizardData: submissionVM,
        updateWizardData,
        goNext,
        steps,
        changeNextSteps,
        isSkipping,
        currentStep
    } = props;
    const viewModelService = useContext(ViewModelServiceContext);
    const [initialPotentialContact, updateInitialPotentialContact] = useState([]);
    const { onValidate } = useValidation('AdditionalInformationPreBindPage');
    const [showErrors, updateShowErrors] = useState(false);
    const [errors, setErrors] = useState([]);
    const [initialSignalResponses, setInitialSignalResponses] = useState([]);
    const [errorTimestamp, setErrorTimestamp] = useState(0);
    const [additionalInterestAvailableCandidatesML, setAdditionalInterestAvailableCandidatesML] = useState([]);
    const { steps: wizardSteps } = wizardConfig;
    const isBundle = submissionVM.isBundle_ML.value;
    const isQnB = appConfig.portalCode === 'QB';
    const isCompRaterPolicy = !isQnB && submissionVM.value.isCompRater();
    const primaryNamedInsuredVM = submissionVM.baseData.primaryNamedInsured_ML;
    const addressVM = submissionVM.baseData.policyAddress;

    const { nextStepVisited } = MLWizardNavUtil(props);

    const {
        showProgressDialog,
        hideProgressDialog
    } = MLModalService();

    const {
        addErrorAlert,
        clearAlerts,
        clearBlockAlerts,
        addWarningAlert
    } = MLNotificationBlockUtil();

    const getSubtype = () => {
        return ADDLINTERESTSUBTYPE;
    };
 
    const getVehicle = _.get(submissionVM, 'lobData.personalAuto.coverables.vehicles.value');
    const hasMissingVin = getVehicle.some((vehicle) => !vehicle.vin);
    useEffect(() => {
        if (hasMissingVin) {
            window.scrollTo(0, 0);
        };
    }, [hasMissingVin]);

        if (hasMissingVin) {
            const vinSection = document.getElementById('vinLookupComponent');
            vinSection?.querySelector('input')?.focus();
        }

    useEffect(() => {
        const setInitialSignalResponsesArray = () => {
            const initialValues = getRatedDrivers().map((driver) => {
                const modifiers = driver?.driverModifiers_ML?.modifiers?.value || [];
                return {
                    driverId: driver?.value?.person?.publicID,
                    modifiers: modifiers.map(mod => ({
                        codeIdentifier: mod?.codeIdentifier_ML,
                        chosenTermValue: mod?.chosenTermValue
                    }))
                };
            });
            setInitialSignalResponses(initialValues);
        };

        setInitialSignalResponsesArray();

        PATrackEvent('Issuance Step Reached', false, submissionVM, null, { step: 'Additional Info to Purchase Page' }, true);
    }, []);

    const isVinDuplicated = useCallback((currentVehicle) => {
        const vehicles = _.get(submissionVM, 'lobData.personalAuto.coverables.vehicles.children', []);
        const vehicleVin = currentVehicle.vin;
        const vehiclesWithTheSameVin = vehicles ? vehicles.filter(
            (x) => !_.isUndefined(x.vin.value) && x.vin.value === vehicleVin.value
        ) : [];
        return vehiclesWithTheSameVin.length >= 2;
    }, [submissionVM]);

    const isRatedDriver = (driverVM) => {
        return driverVM.type_ML.value.code === 'rated';
    };

    const isExcludedDriver = (driverVM) => {
        return driverVM.type_ML.value.code === 'excluded';
    };

    const isInGA = () => {
        return addressVM.state.value && addressVM.state.value.code === 'GA';
    };

    const isInUT = () => {
        return addressVM.state.value && addressVM.state.value.code === 'UT';
    };

    const isPrimaryDriver = (driverVM) => {
        return driverVM.relationshipToInsured_ML.value.code === 'self';
    };

    const skipOnResumeIf = () => {
        // Skip to Confirmation Page for policy with a policy number
        if (!!_.get(submissionVM, 'bindData.policyNumber.value')
            && (submissionVM.value.baseData.status_ML === 'Bound' || submissionVM.value.baseData.status_ML === 'Binding')) {
            return true;
        }

        if (currentStep.path === '/hvq-additional-information-prebind' && !(submissionVM.hvqQuoteID_ML && submissionVM.hvqQuoteID_ML.value)) {
            return true;
        }

        return submissionVM.isBundle_ML.value && submissionVM.value.baseData.status_ML !== 'Draft' &&
            MLMultiLobsDataHolderService.isBeforeLastPurchaseFlowStepVisited('paAddtlInfoToBuy', submissionVM.value);
    };

    useEffect(() => {
        if (!isSkipping || (isSkipping && !skipOnResumeIf())) {
            MLPublicContactsService.getMortgageeContacts().then((data) => {
                updateInitialPotentialContact(data);
            });

            LoadSaveService.getAdditionalInterestCandidatesML(submissionVM.quoteID.value, authHeader).then((candidates) => {
                setAdditionalInterestAvailableCandidatesML(candidates);
            });

            const clonedSubmissionVM = viewModelService.clone(submissionVM);
            _.set(clonedSubmissionVM, 'lobData.personalAuto.coverables.addInterestTypeCategory', getSubtype());
            updateWizardData(clonedSubmissionVM);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!isSkipping || (isSkipping && !skipOnResumeIf())) {
            const vehiclesVM = submissionVM.lobData.personalAuto.coverables.vehicles.children;
            vehiclesVM.map((vehicleVM) => {
                if (!vehicleVM.additionalInterests.value) {
                    vehicleVM.additionalInterests.value = [];
                }
                // Force Vin to be validated again if partial
                if (vehicleVM.vin.value && vehicleVM.vin.value.length < 17 && vehicleVM.year.value && vehicleVM.year.value > 1981) {
                    vehicleVM.vinIntegrationErrorCode_ML.value = null;
                }
                vehicleVM.isVinRequired_ML.value = true;
                vehicleVM.isSerialNumberRequired_ML.value = true;
                return vehicleVM;
            });
            updateWizardData(submissionVM);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!isSkipping || (isSkipping && !skipOnResumeIf())) {
            const driversVM = _.get(submissionVM, 'lobData.personalAuto.coverables.drivers');
            driversVM.forEach((driver) => {
                if (driver.value) {
                    driver.value.reEnterEmailRequired_ML = true;
                }
            });

            driversVM.forEach((driver) => {
                if (driver.value) {
                    if (driver.value.spouseID_ML) {
                        const spouse = _.find(driversVM.value, (s) => s.publicID === driver.value.spouseID_ML);
                        if (spouse) {
                            driver.value.spouse = spouse.person;
                            driver.value.spouse.storedEmailAddress_ML = driver.value.spouse.emailAddress_ML;
                        }
                    }
                    if (isRatedDriver(driver) || isExcludedDriver(driver)) {
                        driver.value.isLicenseNumberRequired_ML = true;
                    }
                    if (isExcludedDriver(driver)) {
                        driver.value.isAgeFirstLicensedRequired_ML = true;
                    }
                    if (isExcludedDriver(driver) && (isInGA() || isInUT())) {
                        driver.value.excludedDriverEmailRequired_ML = true;
                    }

                    if (isPrimaryDriver(driver)) {
                        const emailAddress = driver.person.emailAddress_ML;
                        driver.value.reEnterEmailRequired_ML = !_.isUndefined(emailAddress.value) && !_.isEmpty(emailAddress.value);
                    }

                    if (driver.requiresProof_ML.value === true) {
                        driver.value.isCFRInfoRequired_ML = true;
                        if ((driver.requestingState_ML.value === null || typeof driver.requestingState_ML === 'undefined') && addressVM !== null) {
                            const stateExistsInTypeList = driver.requestingState_ML.aspects.availableValues.some((state) => {
                                return state.code === _.get(submissionVM, 'lobData.personalAuto.policyAddress_ML.state.value.code', undefined);
                            });
                            driver.requestingState_ML = stateExistsInTypeList ? addressVM.state.value : null;
                        }
                    }
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const updateContactDetails = () => {
        updateWizardData(submissionVM);
    };

    const removeErrorAlertIfVehiclesOwned = () => {
        let noOwnedVehiclesNumber = 0;
        const vehiclesVM = _.get(submissionVM, 'lobData.personalAuto.coverables.vehicles.children');

        if (!!vehiclesVM && vehiclesVM.length > 0) {
            vehiclesVM.forEach((vehicleVM) => {
                if (vehicleVM.financeCategory_ML.value.code !== 'owned') noOwnedVehiclesNumber++;
            });
        }
        if (noOwnedVehiclesNumber === 0) {
            clearBlockAlerts('noInterestedPartyInformation');
        }
    };

    const writeValue = useCallback((value, path) => {
        const newSubmissionVM = viewModelService.clone(submissionVM);
        _.set(newSubmissionVM, path, value);
        updateWizardData(newSubmissionVM);
    }, [submissionVM, updateWizardData, viewModelService]);

    const updateSubmissionVM = useCallback(() => {
        updateWizardData(submissionVM);
    }, [submissionVM, updateWizardData]);

    const generateVehiclesOverrides = useCallback(() => {
        const vehicles = _.get(submissionVM, 'lobData.personalAuto.coverables.vehicles.children', []);

        const overrides = vehicles.map((vehicle, index) => {
            return {
                [`vehicleInfoComponent${index}`]: {
                    value: vehicle,
                    submissionVM,
                    isVinDuplicated,
                    index,
                    onValueChange: writeValue,
                    quoteID: submissionVM.quoteID,
                    updateVehicleDetails: updateSubmissionVM,
                    removeErrorAlertIfVehiclesOwned,
                    initialPotentialContact: initialPotentialContact,
                    showValidationErrors: showErrors,
                    onValidate,
                    additionalInterestAvailableCandidatesML
                }
            };
        });

        return Object.assign({}, ...overrides);
    }, [additionalInterestAvailableCandidatesML, initialPotentialContact, isVinDuplicated, onValidate, removeErrorAlertIfVehiclesOwned, showErrors, submissionVM, updateSubmissionVM, writeValue]);

    const getPrimaryDriverSpouse = useCallback(() => {
        const driversPath = 'lobData.personalAuto.coverables.drivers.children';
        const drivers = _.get(submissionVM, driversPath, []);
        const primaryDriverSpouse = _.filter(drivers, (driver) => {
            return driver.relationshipToInsured_ML.value.code === 'spouse';
        });
        return primaryDriverSpouse;
    }, [submissionVM]);

    const updatePrimaryDriverSpouseEmail = useCallback((email) => {
        const driversPath = 'lobData.personalAuto.coverables.drivers.children';
        const drivers = _.get(submissionVM, driversPath, []);
        const primaryDriverSpouse = _.filter(drivers, (driver) => {
            return driver.relationshipToInsured_ML.value.code === 'spouse';
        });
        const spouseIndex = drivers.indexOf(primaryDriverSpouse[0]);
        _.set(submissionVM, `${driversPath}.${spouseIndex}.person.emailAddress_ML.value`, email);
        updateWizardData(submissionVM);
    }, [submissionVM, updateWizardData]);

    const getRatedDrivers = () => {
        const driversPath = 'lobData.personalAuto.coverables.drivers.children';
        const drivers = _.get(submissionVM, driversPath, []);

        const getDriverSortPriority = (driverVM) => {
            if (isPrimaryDriver(driverVM)) {
                return 0;
            }
            switch (driverVM.type_ML.value.code) {
                case 'rated':
                    return 1;
                case 'household':
                    return 2;
                case 'excluded':
                    return 3;
                default:
                    return 9;
            }
        };

        const getSortedDriversVM = (driversToSort) => {
            return driversToSort.sort((drv1VM, drv2VM) => {
                const drv1Priority = getDriverSortPriority(drv1VM);
                const drv2Priority = getDriverSortPriority(drv2VM);

                if (drv1Priority < drv2Priority) {
                    return -1;
                }

                if (drv1Priority > drv2Priority) {
                    return 1;
                }

                return 0;
            });
        };

        const driversToSort = [...drivers];
        const sortedDrivers = getSortedDriversVM(driversToSort);

        const ratedDrivers = _.filter(
            sortedDrivers,
            (driver) => {
                return driver.type_ML.value.code === 'rated';
            }
        );
        return ratedDrivers;
    }
    
    const validateSignalProgram = (drivers) => {
        return drivers.some((driver) => {
            const signalProgram = _.get(driver, 'driverModifiers_ML.modifiers.value[0].chosenTermValue');
            const phoneNumber = _.get(driver, 'driverModifiers_ML.modifiers.value[1].chosenTermValue');
 
            return ( (signalProgram === 'true' || signalProgram === true) && _.isEmpty(phoneNumber));
        });
    };

    const disableValidationForDependentModifiers = (mod) => {
        if (mod && mod.hasDependentModifier_ML.value) {
            getRatedDrivers().forEach((driver) => {
                if (!_.isEmpty(driver.driverModifiers_ML)) {
                    driver.driverModifiers_ML.modifiers.forEach((modifier) => {
                        if (modifier.isDependentModifier_ML) {
                            modifier.editMode_ML = false;
                        }
                    });
                }
            });
        }
    };

    const initVehicleValue = (vehicle) => {
        if (!vehicle.value_ML || vehicle.value_ML.amount === 0) {
            vehicle.value_ML = {};
        }
        vehicle.tempID = (vehicle.publicID) ? vehicle.publicID : vehicle.tempID;
    };

    const updateModifiers = (mod) => {
        const setEditMode = (editMode) => submissionVM.value.lobData.personalAuto.coverables.drivers.forEach((driver) => {
            driver.editMode_ML = editMode;
            driver.isLicenseNumberRequired_ML = editMode;
        });

        disableValidationForDependentModifiers(mod);
        // Disable validation so we can update the model and the driver modifiers with it
        setEditMode(false);
        const submissionLoadPromise = LoadSaveService.updateModifiers(submissionVM.value, authHeader);
        showProgressDialog(platformMessages.syncing, submissionLoadPromise, true);
        submissionLoadPromise.then((qdd) => {
            submissionVM.value.lobData.personalAuto.coverables.drivers.length = 0;
            const sortedDrivers = _.sortBy(qdd.lobData.personalAuto.coverables.drivers, (driver) => {
                if (driver.publicID) {
                    return _.toInteger(driver.publicID.split(':')[1]);
                }
                return undefined;
            });
            sortedDrivers.forEach((driver) => {
                if (driver.person) {
                    driver.person = submissionVM.value.findPerson(submissionVM.value, driver.person);
                }
            });
            _.set(submissionVM, 'value.lobData.personalAuto.coverables.drivers', sortedDrivers);

            if (mod?.codeIdentifier_ML?.value === 'PADriverSignalProgram_Ext') {
                submissionVM.value.lobData.personalAuto.coverables.vehicles.length = 0;
                qdd.lobData.personalAuto.coverables.vehicles.forEach((updatedVehicle, index) => {
                    initVehicleValue(updatedVehicle);
                    submissionVM.value.lobData.personalAuto.coverables.vehicles.push(updatedVehicle);
                });
            }

        }, (error) => {
            console.error(error);
            if (!submissionVM.aspects.valid || !submissionVM.aspects.subtreeValid) {
                updateShowErrors(true);
                setTimeout(() => {
                    setErrorTimestamp(errorTimestamp + 1);
                }, 500);
                return false;
            }
        }).finally(() => {
            setModifierEditMode(submissionVM.value.lobData.personalAuto.coverables.drivers, true);
            setEditMode(true);
            updateWizardData(submissionVM);
        });
    };

    const generateDriversOverrides = useCallback(() => {
        const driversPath = 'lobData.personalAuto.coverables.drivers.children';
        const drivers = _.get(submissionVM, driversPath, []);
        const policyAddress = _.get(submissionVM, 'baseData.policyAddress');

        const getDriverSortPriority = (driverVM) => {
            if (isPrimaryDriver(driverVM)) {
                return 0;
            }
            switch (driverVM.type_ML.value.code) {
                case 'rated':
                    return 1;
                case 'household':
                    return 2;
                case 'excluded':
                    return 3;
                default:
                    return 9;
            }
        };

        const getSortedDriversVM = (driversToSort) => {
            return driversToSort.sort((drv1VM, drv2VM) => {
                const drv1Priority = getDriverSortPriority(drv1VM);
                const drv2Priority = getDriverSortPriority(drv2VM);

                if (drv1Priority < drv2Priority) {
                    return -1;
                }

                if (drv1Priority > drv2Priority) {
                    return 1;
                }

                return 0;
            });
        };

        const driversToSort = [...drivers];
        const sortedDrivers = getSortedDriversVM(driversToSort);

        const ratedDrivers = _.filter(
            sortedDrivers,
            (driver) => {
                return driver.type_ML.value.code === 'rated';
            }
        );
        const excludedDrivers = _.filter(
            sortedDrivers,
            (driver) => {
                return driver.type_ML.value.code === 'excluded';
            }
        );
        const getIndexFromDriverList = (specificDriver) => {
            const driverIndex = drivers.indexOf(specificDriver);
            return driverIndex;
        };

        const ratedOverrides = ratedDrivers.map((driver, index) => {
            return {
                [`ratedDriverComponent${index}`]: {
                    value: driver,
                    index,
                    policyAddress,
                    path: `${driversPath}.${getIndexFromDriverList(driver)}`,
                    primaryDriverSpouse: getPrimaryDriverSpouse(),
                    onValueChange: writeValue,
                    updatePrimaryDriverSpouseEmail,
                    showValidationErrors: showErrors,
                    onValidate,
                    updateDrivers: updateSubmissionVM,
                    submissionVM,
                    validateEmailAddress,
                    updateModifiers
                }
            };
        });

        const excludedOverrides = excludedDrivers.map((driver, index) => {
            return {
                [`excludedDriverComponent${index}`]: {
                    value: driver,
                    index,
                    policyAddress,
                    path: `${driversPath}.${getIndexFromDriverList(driver)}`,
                    onValueChange: writeValue,
                    showValidationErrors: showErrors,
                    onValidate
                }
            };
        });
        return Object.assign({}, ...ratedOverrides, ...excludedOverrides);
    }, [getPrimaryDriverSpouse, onValidate, showErrors, submissionVM, updatePrimaryDriverSpouseEmail, updateSubmissionVM, writeValue]);

    const getriverListOfType = (type) => {
        const drivers = _.get(submissionVM, 'lobData.personalAuto.coverables.drivers.children', []);
        const ratedDrivers = _.filter(
            drivers,
            (driver) => {
                return driver.type_ML.value.code === type;
            }
        );
        return ratedDrivers;
    };

    const checkIfOnePhoneNumberTypedAndSetAsPrimary = () => {
        const primaryPhoneTypes = viewModelService.productMetadata.get('pc').types.getTypelist('PrimaryPhoneType');
        const cellNumber = primaryNamedInsuredVM.cellNumber.value;
        const workNumber = primaryNamedInsuredVM.workNumber.value;
        const homeNumber = primaryNamedInsuredVM.homeNumber.value;
        const homePrimaryPhoneTypeCode = 'home';
        const workPrimaryPhoneTypeCode = 'work';
        const cellPrimaryPhoneTypeCode = 'mobile';
        if (cellNumber && !(workNumber || homeNumber)) {
            primaryNamedInsuredVM.primaryPhoneType = primaryPhoneTypes.getCode(cellPrimaryPhoneTypeCode);
        } else if (workNumber && !(cellNumber || homeNumber)) {
            primaryNamedInsuredVM.primaryPhoneType = primaryPhoneTypes.getCode(workPrimaryPhoneTypeCode);
        } else if (homeNumber && !(cellNumber || workNumber)) {
            primaryNamedInsuredVM.primaryPhoneType = primaryPhoneTypes.getCode(homePrimaryPhoneTypeCode);
        }
    };

    const doesVehiclesHaveValidVin = () => {
        const vehiclesVM = submissionVM.lobData.personalAuto.coverables.vehicles.children;
        const invalidReturnCodes = ['5', '4', 'N', '6', 'S', 'L', 'X'];
        return !vehiclesVM.some((vehicle) => vehicle.year.value && vehicle.year.value > 1981 && vehicle.vin.value && vehicle.isVinRequired_ML.value && (!vehicle.vinIntegrationErrorCode_ML.value || invalidReturnCodes.indexOf(vehicle.vinIntegrationErrorCode_ML.value) >= 0));
    };

    const {
        validateVehiclesSerialNumber,
        checkHiDrivers,
        checkPendingMvrOrderStatus,
        setModifierEditMode,
        hasDuplicateSignalPhoneNumbers
    } = MLDriverVehicleUtil();

    const hasPALeaseLoanCovButChangedOwnership = (vehicleVM) => {
        const vehicle = vehicleVM.value;
        return vehicle.hasPALeaseLoanCov_ML
            && vehicle.financeCategory_ML !== vehicle.orgFinanceCategory_ML;
    };

    const isFinanceWithoutPALeaseLoanCovButNoLienHolder = (vehicleVM) => {
        const vehicle = vehicleVM.value;
        return vehicle.hasPALeaseLoanCov_ML !== true
            && vehicle.financeCategory_ML === 'financed'
            && vehicle.additionalInterests.filter((addInt) => addInt.type === 'LIEN').length === 0;
    };

    const isOwnedButWithLienHolderLessor = (vehicleVM) => {
        const vehicle = vehicleVM.value;
        return vehicle.financeCategory_ML === 'owned'
            && _.filter(vehicle.additionalInterests, (addInt) => {
                return addInt.type === 'LIEN' || addInt.type === 'LEASINGCOMPANY';
            }).length !== 0;
    };

    const isLeaseButNoLessor = (vehicleVM) => {
        const vehicle = vehicleVM.value;
        return vehicle.financeCategory_ML === 'leased'
            && _.filter(vehicle.additionalInterests, (addInt) => addInt.type === 'LEASINGCOMPANY').length === 0;
    };

    const showVehicleOwnershipErrorMessages = (vehiclesVM) => {
        const errorMessages = [];
        clearAlerts();
        setErrors([]);

        if (!!vehiclesVM && vehiclesVM.length > 0) {
            vehiclesVM.forEach((vehicleVM) => {
                let errorMsg = null;
                let errorName = null;

                if (hasPALeaseLoanCovButChangedOwnership(vehicleVM)) {
                    errorMsg = translator(messages.hasPALeaseLoanCovButChangedOwnership);
                    errorName = 'removeLeaseLoanGap';
                }
                if (isFinanceWithoutPALeaseLoanCovButNoLienHolder(vehicleVM) || isLeaseButNoLessor(vehicleVM)) {
                    errorMsg = translator(messages.isFinanceWithoutPALeaseLoanCovButNoLienHolderOrLeaseButNoLessor);
                    errorName = 'noInterestedPartyInformation';
                }
                if (isOwnedButWithLienHolderLessor(vehicleVM)) {
                    errorMsg = translator(messages.isOwnedButWithLienHolderLessor);
                    errorName = 'updateOwnedFinanceLeasedField';
                }
                if (!!errorMsg && !!errorName) {
                    addErrorAlert(errorMsg, errorName);
                    errorMessages.push(errorMsg);
                }
            });
        }
        setErrors(errorMessages);
        return errorMessages;
    };

    const isInCO = () => {
        return addressVM.state.value && addressVM.state.value.code === 'CO';
    };

    const validateEmailAddress = (accountContactDetailsVm) => {
        const account = accountContactDetailsVm;
        let emailAddress1 = _.get(account, 'emailAddress_ML.value');
        if (emailAddress1) {
            emailAddress1 = emailAddress1.trim();
        }
        let isValidEmailEntred = /^[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/.test(emailAddress1)
        if (isValidEmailEntred) {
            const checkEmailVerified_Ext = EmailValidationService.checkEmailVerified_Ext(
                emailAddress1,
                authHeader
            );
            showProgressDialog(platformMessages.loading, checkEmailVerified_Ext, true);
            checkEmailVerified_Ext.then((res) => {
                hideProgressDialog(platformMessages.loading, checkEmailVerified_Ext, true);
                if (res == true) {
                    _.set(account, 'emailVerified_Ext.value', true);
                    _.set(account, 'emailAddress_ML.value', emailAddress1);
                }
                else {
                    _.set(account, 'emailVerified_Ext.value', false);
                    _.set(account, 'emailAddress_ML.value', emailAddress1 + " ");
                }
            }).catch((e) => {
                clearBlockAlerts('invalidEmail');
                addWarningAlert(translator(messages.invalidEmail), 'invalidEmail');
                _.set(account, 'emailVerified_Ext.value', false);
                _.set(account, 'emailAddress_ML.value', emailAddress1);
                hideProgressDialog(platformMessages.loading, checkEmailVerified_Ext, true);
                console.log(e);
                window.scrollTo(0, 0);
            });
        }

    };

    const validateSpouseEmail = () => {
        const errorMsgValidateSpouseEmail = translator(messages.uniqueEmailAddress);
        addErrorAlert(errorMsgValidateSpouseEmail, 'spouseEmailValidation');
        return errorMsgValidateSpouseEmail;
    };

    const nextStepText_Ext = () => {
        return (
            <FormattedMessage
                {...messages.continueText}
                values={{
                    purchaseDetails: (
                        <strong>{translator(messages.purchaseDetailsText)}</strong>
                    )
                }}
            />
        );
    };

    const generateErrorsOverrides = () => {
        const overrides = errors.map((error, index) => {
            return {
                [`error${index}`]: {
                    messageProps: {
                        error: error
                    }
                }
            };
        });

        return Object.assign({}, ...overrides);
    };

    const overrideProps = {
        paAdditionalInfoIterable: {
            data: submissionVM.lobData.personalAuto.coverables.vehicles.children
        },
        additionalInfoRatedDriverIterable: {
            data: getriverListOfType('rated')
        },
        additionalInfoExcludedDriverIterable: {
            data: getriverListOfType('excluded')
        },
        ratedDriverComponent: {
            submissionVM: submissionVM
        },
        nextDescription: {
            content: nextStepText_Ext()
        },
        addressDetailsSection: {
            visible: isCompRaterPolicy
        },
        phoneNumberSection: {
            visible: isCompRaterPolicy
        },
        paAdditionalInformatonPageTitle: {
            className: isQnB ? "page-header headerOne" : "page-header"
        },
        addressDetailsComponent: {
            addressVM: addressVM,
            onModelChange: updateContactDetails,
            layout: 'ml-policy-change',
            onValidate: onValidate,
            showValidationErrors: showErrors
        },
        contactDetailsComponent: {
            accountContactDetailsVm: primaryNamedInsuredVM,
            writeValue,
            path: 'baseData.primaryNamedInsured_ML',
            showValidationErrors: showErrors,
            updateContactVM: updateContactDetails,
            showPrimaryEmailAddress: false,
            onValidate
        },
        ...generateVehiclesOverrides(),
        ...generateDriversOverrides(),
        ...generateErrorsOverrides()
    };

    const loadCoveragesForChosenQuote = async () => {
        const chosenQuoteVal = _.get(submissionVM, 'bindData.chosenQuote.value', undefined);
        const customQuoteDTO = {
            sessionUUID: submissionVM.sessionUUID.value,
            quoteID: submissionVM.quoteID.value,
            quoteBaseVersion_ML: chosenQuoteVal,
            customizableQuote_ML: false
        };
        const lobs = await CustomQuoteService.getCoverageLobsForOffering(customQuoteDTO)
        const chosenQuote = _.find(submissionVM.quoteData.offeredQuotes.value, (offeredQuote) => {
            return offeredQuote.publicID === chosenQuoteVal;
        });
        if (chosenQuote) {
            chosenQuote.lobs = lobs;
        }
    };

    const validateAddressAndProceed = async () => {
        const validateAddressStatus = _.get(submissionVM, 'baseData.policyAddress.validateAddressStatus_ML.value');

        if (isCompRaterPolicy && (_.isUndefined(validateAddressStatus) || validateAddressStatus === false)) {
            try {
                await MLAddressVerificationService.validateAddress(viewModelService, _.get(submissionVM, 'baseData.policyAddress'));
            } catch (err) {
                return false;
            }
        }
    };

    const shouldShowDisclosures = () => {
        const getSelectedQuote = () => {
            const selectedQuoteId = _.get(submissionVM, 'bindData.chosenQuote.value');
            const offeredQuotes = _.get(submissionVM, 'quoteData.offeredQuotes.value', []);
            return offeredQuotes.find((q) => q.publicID === selectedQuoteId);
        };

        let violations = [];
        const selectedQuote = getSelectedQuote();
        if (selectedQuote === undefined) {
            return false;
        }

        const populateViolations = () => {
            const drivers = submissionVM.lobData.personalAuto.coverables.drivers.value;
            violations = drivers.flatMap((driver) => driver.disclosures_ML.violations);
        };

        const foundViolationsFromMVR = () => {
            return violations.some((v) => v.undisclosedActivity_ML === true);
        };


        const checkHIDriverMVR = () => {
            const drivers = submissionVM.lobData.personalAuto.coverables.drivers.value;
            if (checkHiDrivers(drivers) && checkPendingMvrOrderStatus(drivers))
                return true;
            return false;
        };


        const getFormerCostsAndGoNext = () => {
            const costsAreEqual = (costA, costB) => {
                if (costA && costB) {
                    return costA.amount === costB.amount && costA.currency === costB.currency;
                }
                return true;
            };

            return new Promise((resolve) => {
                let premiumsMatch = false;

                const storagePromise = MLPortalStorageService.retrieve(submissionVM.quoteID.value, null, ML_STORAGE_KEY_PREVIOUS_PREMIUM);
                showProgressDialog(platformMessages.synchronizingQuote, storagePromise);
                storagePromise.then((response) => {
                    if (response) {
                        const formerCosts = JSON.parse(response);
                        const matchingQuote = formerCosts.find((quote) => { return quote.branchCode === selectedQuote.branchCode; });

                        if (matchingQuote) {
                            premiumsMatch = costsAreEqual(matchingQuote.monthlyPremium, selectedQuote.premium.monthlyPremium) || costsAreEqual(matchingQuote.total, selectedQuote.premium.total);
                        }
                    }
                });
                storagePromise.finally(() => {
                    MLDisclosureUtil.setRequoteAfterMvr(submissionVM.quoteID.value, true);
                    return resolve(!premiumsMatch);
                });
            });
        };

        populateViolations();
        if (foundViolationsFromMVR()) {
            return true;
        }
        if (checkHIDriverMVR()) {
            return true;
        }
        return getFormerCostsAndGoNext();
    };

    const shouldPrefillEmailAddress = () => {
        const prefillCandidate = MLBundleService.getPrefillEmailCandidate();

        return isBundle && prefillCandidate.emailAddress;
    };

    const showPrimaryPhoneValidation = () => {
        const errorMsgPrimaryPhoneValidation = translator(messages.onePhoneTypeMustBePrimary);
        addErrorAlert(errorMsgPrimaryPhoneValidation, 'primaryPhoneValidation');
        return errorMsgPrimaryPhoneValidation;
    };

    const checkForMandatoryFieldForSignalProgram = () => {
        let isValid = true;
        getRatedDrivers().forEach((driver) => {
            const modifiersList = driver?.driverModifiers_ML?.modifiers;
            if (Array.isArray(modifiersList.value)) {
                modifiersList.value.forEach((modifier) => {
                    if (modifier.codeIdentifier_ML === "PADriverSignalProgramPhoneNumber_Ext") {
                        if (modifier?.chosenTermValue === null || modifier?.chosenTermValue === undefined || modifier?.chosenTermValue === "") {
                            isValid = false;
                            modifier.isInputValueRequired_ML = true;
                        }
                        if (modifier?.chosenTermValue && modifier?.chosenTermValue?.length !== 10) {
                            isValid = false;
                        }
                    }
                });
            }
        });
        return isValid;
    };

    const hasSignalResponsesChanged = () => {
        return getRatedDrivers().some((driver) => {
            const driverId = driver?.value?.person?.publicID;
            const currentModifiers = driver?.driverModifiers_ML?.modifiers?.value || [];

            const initial = initialSignalResponses.find(item => item?.driverId === driverId);
            const initialModifiers = initial?.modifiers || [];

            return currentModifiers.some((mod) => {
                const initialMod = initialModifiers.find(im => im.codeIdentifier === mod?.codeIdentifier_ML);
                return initialMod?.chosenTermValue !== mod?.chosenTermValue;
            });
        });
    };

    const requoteSubmission = async () => {
        const saveAndQuotePromise = LoadSaveService.updateQuotedSubmission(submissionVM.value, authHeader);
        showProgressDialog(messages.calculatingQuote, saveAndQuotePromise);
        const qdd = await saveAndQuotePromise;
        const newSubmissionVM = _.clone(submissionVM);
        _.set(newSubmissionVM, 'value', qdd);
        updateWizardData(newSubmissionVM);
    };

    const hasDuplicateLicenseNumber = () => {
        const drivers = submissionVM.lobData.personalAuto.coverables.drivers.value || [];
 
        const allLicenseNumbers = drivers
            .map((driver) => driver.licenseNumber?.trim().toUpperCase())
            .filter(Boolean);
 
        return new Set(allLicenseNumbers).size !== allLicenseNumbers.length;
    };

    const onNext = async () => {

        if (hasDuplicateLicenseNumber()) {
            addErrorAlert(
            messages.showDuplicateLicenseErrorQB,
            "duplicateLIcense",
          );
            return false;
        }

        if (validateSignalProgram(getRatedDrivers())) {
            addErrorAlert(
            messages.SignalPhoneNumberMessageQB,
            "mandatoryFields",
          );

          return false;
        } 

        if (!checkForMandatoryFieldForSignalProgram()) {
            updateShowErrors(true);
            setTimeout(() => {
                setErrorTimestamp(errorTimestamp + 1);
            }, 500);
            return false;
        }

        if (hasDuplicateSignalPhoneNumbers(getRatedDrivers())) {
          addErrorAlert(
            messages.duplicateSignalPhoneNumberMessageQB,
            "duplicateSignalPhone",
          );

          return false;
        }
        
        await validateAddressAndProceed();

        checkIfOnePhoneNumberTypedAndSetAsPrimary();

        const valid = submissionVM.aspects.valid && submissionVM.aspects.subtreeValid;

        if (!valid) {
            updateShowErrors(true);
            setErrorTimestamp(errorTimestamp + 1);
            return false;
        }

        let isRequoted = false;
        if (hasSignalResponsesChanged()) {
            isRequoted = true;
            await requoteSubmission();
        }

        let errorMessages;
        if (isCompRaterPolicy) {
            // set submissionVM.isSubmitAgent to true to validate account contact primary phone type and show validation error
            submissionVM.isSubmitAgent.value = true;
            if (!primaryNamedInsuredVM.primaryPhoneType.value) {
                errorMessages = showPrimaryPhoneValidation();
                window.scrollTo(0, 0);
            }
        }

        PATrackEvent('Issuance Step Submitted', false, submissionVM, null, { step: 'Additional Info to Purchase Page' }, true);

        const vehiclesVM = submissionVM.lobData.personalAuto.coverables.vehicles.children;
        if (submissionVM.aspects.valid && submissionVM.aspects.subtreeValid && doesVehiclesHaveValidVin() && validateVehiclesSerialNumber(vehiclesVM)) {
            errorMessages = showVehicleOwnershipErrorMessages(vehiclesVM);
            if (errorMessages.length === 0) {
                const primaryDriverSpouse = getPrimaryDriverSpouse();
                const primaryDriverSpouseEmail = primaryDriverSpouse[0] ? primaryDriverSpouse[0].person.emailAddress_ML : null;

                const driversVM = _.get(submissionVM, 'lobData.personalAuto.coverables.drivers.children');
                const primaryDriver = _.find(driversVM, (driver) => isPrimaryDriver(driver));
                const primaryDriverEmail = primaryDriver ? primaryDriver.person.emailAddress_ML : undefined;
                if (shouldPrefillEmailAddress()) {
                    const prefillFrom = MLBundleService.getPrefillEmailCandidate();
                    primaryDriverEmail.value = prefillFrom.emailAddress;
                }
                if (isInCO() && !!primaryDriverSpouseEmail
                    && primaryDriverSpouseEmail.value === primaryDriverEmail.value) {
                    errorMessages = validateSpouseEmail();
                }
            }
            await loadCoveragesForChosenQuote();
            if (errorMessages.length === 0) {
                showProgressDialog(platformMessages.saveSubmission);
                try {
                    _.set(submissionVM, 'portalCurrentStep_ML.value', 'paAddtlInfoToBuy');
                    submissionVM.value = await LoadSaveService.updateQuotedSubmission(submissionVM.value);
                    const shouldShowAdjustmentPage = await shouldShowDisclosures();
                    if (!shouldShowAdjustmentPage) {
                        const index = _.findIndex(
                            steps,
                            ({ path }) => path === '/adjustments'
                        );
                        if (index > 0) {
                            const remainingSteps = _.slice(steps, index + 1);
                            changeNextSteps(remainingSteps);
                        }
                    } else {
                        const hasAdjustmentsStep = steps.some((step) => step.path === '/adjustments');
                        if (!hasAdjustmentsStep) {
                            const adjustmentIndex = _.findIndex(
                                wizardSteps, ({ path }) => path === '/adjustments'
                            );
                            const nextSteps = _.slice(wizardSteps, adjustmentIndex);
                            changeNextSteps(nextSteps);
                        }
                    }
                    if (!nextStepVisited()) {
                        return submissionVM;
                    }
                    goNext();
                    return false;
                } finally {
                    hideProgressDialog();
                }
            }
            window.scrollTo(0, 0);
            return false;
        } if (!doesVehiclesHaveValidVin() || !validateVehiclesSerialNumber(vehiclesVM)) {
            window.scrollTo(0, 0);
            return false;
        }
        return false;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    };

    const resolvers = {
        resolveComponentMap: {
            addtlinterestdrivercomponent: AddtlInterestDriverComponent,
            addtlinterestexcludeddrivercomponent: AddtlInterestExcludedDriverComponent,
            mlAddressDetailsComponent: MLAddressDetailsComponent,
            mlEditContactDetailsComponent: MLEditContactDetailsComponent
        },
        resolveCallbackMap: {
            onNext: onNext
        }
    };

    return (
        <WizardPage
            showPrevious={false}
            showCancel={false}
            skipWhen={skipOnResumeIf}
            showNext={!nextStepVisited()}
            onNext={onNext}
            nextLabel={translator(platformMessages.mlContinue)}
            showTextNextToButton={!nextStepVisited()}
            textNextToButton={nextStepText_Ext()}
            metadataPageId={!nextStepVisited() && _.get(metadata, 'pageContent.id')}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                onModelChange={updateWizardData}
                componentMap={resolvers.resolveComponentMap}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={styles}
                overrideProps={overrideProps}
                showErrors={showErrors}
            />
            <ScrollToError counter={errorTimestamp} />
        </WizardPage>
    );
};

AdditionalInformationPreBindPage.propTypes = wizardProps;
export default AdditionalInformationPreBindPage;
